import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import table from './modules/table'
import products from './modules/products'
import categories from './modules/categories'
import brands from './modules/brands'
import manufacturers from './modules/manufacturers'
import vehicules from './modules/vehicules'
import notifications from './modules/notifications'
import features from './modules/features'
import variationValues from './modules/variationValues'
import users from './modules/users'
import files from './modules/files'

Vue.use(Vuex)


const store = new Vuex.Store({
    modules: {
        app,
        table,
        products,
        brands,
        manufacturers,
        vehicules,
        categories,
        notifications,
        features,
        variationValues,
        users,
        files,
    }
})

export default store
